import { z } from "zod";
import { DataIdSchema } from "./auth";

export const GetRemindersParamsSchema = z.object({
	search: z.string().optional(),
	is_done: z.boolean().optional(),
	page: z.number().int().optional(),
	limit: z.number().int().optional(),
});

export type GetRemindersParamsSchema = z.infer<typeof GetRemindersParamsSchema>;

export const PutReminderCheckBodySchema = z.object({
	id: DataIdSchema,
	is_done: z.boolean(),
});

export type PutReminderCheckBodySchema = z.infer<
	typeof PutReminderCheckBodySchema
>;

export const ReminderFormFieldSchema = z.object({
	id: DataIdSchema.optional(),
	name: z.string().min(1),
	alarm: z.any().optional(),
	repeat: z
		.enum(["Never", "Daily", "Weekly", "Monthly", "Yearly"])
		.default("Never"),
	notes: z.string().optional(),
	remind_me: z.boolean().default(false),
});

export type ReminderFormFieldSchema = z.infer<typeof ReminderFormFieldSchema>;

export const CreateReminderSearchParamsSchema = z.object({
	message: DataIdSchema.optional(),
});

export type CreateReminderSearchParamsSchema = z.infer<
	typeof CreateReminderSearchParamsSchema
>;
